import Vue from 'vue';

export const featureInfo = {
  namespaced: true,
  state: {
    results: [],
    selectedLayer: null,
    selectedFeature: null,
  },
  mutations: {
    CLEAR_QUERY(state) {
      state.results = [];
    },
    SELECT_QUERY_LAYER(state, layer) {
      state.selectedLayer = layer;
    },
    SELECT_QUERY_FEATURE(state, feature) {
      state.selectedFeature = feature;
    },
    UPDATE_QUERY_RESULTS(state, data) {
      // filter the data and only save ones that actually have features
      state.results = data;
    },
  },
  actions: {
    SELECT_QUERY_LAYER({state, commit}, layer) {
      if (state.results[layer].features.length === 1) {
        commit('SELECT_QUERY_LAYER', layer);
        commit('SELECT_QUERY_FEATURE', 0);
      } else {
        commit('SELECT_QUERY_LAYER', layer);
      }
    },
    UPDATE_QUERY_RESULTS({commit}, data) {
      const results = data.filter(res => res?.features?.length);
      commit('UPDATE_QUERY_RESULTS', results);

      if (results.length === 1) {
        commit('SELECT_QUERY_LAYER', 0);

        if (results[0].features.length === 1) {
          commit('SELECT_QUERY_FEATURE', 0);
        } else {
          commit('SELECT_QUERY_FEATURE', null);
        }
      } else {
        commit('SELECT_QUERY_FEATURE', null);
        commit('SELECT_QUERY_LAYER', null);
      }
    },
  },
  getters: {}
};
